<template>
    <div class="form-page text-center d-flex justify-content-center align-items-center">
        
        <main class="form-signin">
            <div class="w-100 d-flex justify-content-center mb-4 pb-4">
                <img class="logo-img d-flex justify-content-center" src="@/assets/logo-crop.png" alt="" srcset="">
            </div>

            <div class="card card-small-box" v-if="finished" :style="errors.length > 0 ? 'max-height: 500px' : 'max-height: 450px'">                
                <h2 class="my-4">Application Under Review</h2>

                <p>Our team will review your application, and you'll receive an email with feedback.</p>

                <div class="text-center">
                    <a href="javascript:;" @click="goTo('login')">Back to Login</a>
                </div>
            </div>
            <div class="card card-small-box" v-else :style="errors.length > 0 ? 'max-height: 700px' : 'max-height: 650px'">
                <div v-if="qr_code">
                    <h2 class="mb-4">Setup Two Factor Authentication</h2>
                    <ul style="text-align: left;">
                        <li class="my-2">1. Install <strong>Google Authenticator</strong> to your phone</li>
                        <li class="my-2">2. Open Google Authenticator</li>
                        <li class="my-2">3. Add a new site with <strong>+</strong></li>
                        <li class="my-2">4. Scan the QR code below</li>
                    </ul>
                    <img style="height: 150px; width: auto;" :src="'data:image/png;base64,' + qr_code" alt="QR Code for 2FA Setup" />
                    <div class="w-100 my-4">
                        <input type="text" v-model="form.key" placeholder="Code" @keydown="clearField('key')">
                    </div>
                    <button @click="verifyKey()" type="button" class="login-button">Verify</button>
                </div>
                <div v-else>
                    <div v-if="loading" class="spinner-border text-danger m-auto" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div v-else>
                        <div class="right-container-box my-4">
                            <h2>Sign Up</h2>
                        </div>
                        <div v-for="(error, index) in errors" :key="index" class="alert alert-danger" role="alert">
                            {{ error }}
                        </div>
                        <form>
                            <div class="w-100 mt-2">
                                <input type="text" v-model="form.username" placeholder="Username" @keydown="clearField('username')">
                            </div>
                            
                            <div class="w-100 mt-2">
                                <input type="text" v-model="form.first_name" placeholder="First name" @keydown="clearField('first_name')">
                            </div>

                            <div class="w-100 mt-2">
                                <input type="text" v-model="form.last_name" placeholder="Last name" @keydown="clearField('last_name')">
                            </div>

                            <div class="w-100 mt-2">
                                <input type="email" v-model="form.email" placeholder="Your email address" @keydown="clearField('email')">
                            </div>

                            <div class="w-100 mt-2">
                                <input :type="passwordType" v-model="form.password" placeholder="Password" @keydown="clearField('password')">
                                <span class="field-icon" @click="togglePassword()">
                                    <font-awesome-icon :icon="['fas', 'eye-slash']" v-if="showPassword" />
                                    <font-awesome-icon :icon="['fas', 'eye']" v-else />
                                </span>
                            </div>

                            <div class="w-100 mt-2">
                                <input :type="confirmPasswordType" v-model="form.confirmPassword" placeholder="Confirm Password" @keydown="clearField('confirmPassword')">
                                <span class="field-icon" @click="toggleConfirmPassword()">
                                    <font-awesome-icon :icon="['fas', 'eye-slash']" v-if="showConfirmPassword" />
                                    <font-awesome-icon :icon="['fas', 'eye']" v-else />
                                </span>
                            </div>

                            <div class="buttons d-flex justify-content-between mt-4">
                                <button @click="goTo('login')" class="register-button">
                                    Back to Login
                                </button>
                                <button @click="signUp()" type="button" class="login-button">Sign Up</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {
    SIGNUP,
    SETUP2FA,
    VERIFY2FA,
} from '@/data/url';
import { toast } from 'vue3-toastify';

export default {
    name: 'SignupPage',
    data() {
        return {
            backendURL: process.env.VUE_APP_BACKEND_URL,
            errors: [],
            form: {
                username: "",
                first_name: "",
                last_name: "",
                email: "",
                password: "",
                confirmPassword: "",
                key: "",
            },
            showPassword: false,
            showConfirmPassword: false,
            loading: false,
            finished: false,
            showQRCode: false,
            qr_code: "",
        }
    },
    computed: {
        passwordType() {
            return this.showPassword ? 'text' : 'password'
        },
        confirmPasswordType() {
            return this.showConfirmPassword ? 'text' : 'password'
        }
    },
    methods: {
        async setSetup() {
            this.errors = [];
            if(!this.form.username) {
                toast.error('The username is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }
            
            if(!this.form.password) {
                toast.error('The password is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }

            this.loading = true;

            try {
                const url = this.backendURL + SETUP2FA;

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: this.form.username,
                        password: this.form.password,
                    })
                });

                const data = await response.json();

                if (data.error) {
                    this.errors.push(data.error || 'Login failed. Please try again.');
                } else {
                    this.qr_code = data.qr_code;
                }

                this.loading = false;
            } catch (error) {
                console.log('error', error)
            }
        },
        async verifyKey() {
            this.errors = [];

            if(!this.form.key) {
                toast.error('The key is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }

            this.loading = true;

            try {
                const url = this.backendURL + VERIFY2FA;

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: this.form.username,
                        password: this.form.password,
                        key: this.form.key,
                    })
                });

                const data = await response.json();

                if (data.error) {
                    this.errors.push(data.error || 'Login failed. Please try again.');
                } else {
                    this.finished = data.status
                }

                this.loading = false;

            } catch (error) {
                console.log('error', error)
            }
        },
        async signUp() {
            this.errors = [];
            if(!this.form.username) {
                toast.error('The username is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }

            if(!this.form.first_name) {
                toast.error('The first name is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }


            if(!this.form.last_name) {
                toast.error('The last name is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }

            if(!this.form.email) {
                toast.error('The email is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }

            if(!this.form.password) {
                toast.error('The password is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }

            if(!this.form.confirmPassword) {
                toast.error('The confirm password is required.', {
                    position: 'top-right',
                    autoClose: 2000,
                });
                return;
            }

            this.loading = true;

            try {
                const url = this.backendURL + SIGNUP;

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: this.form.username,
                        first_name: this.form.first_name,
                        last_name: this.form.last_name,
                        email: this.form.email,
                        password: this.form.password,
                        confirm_password: this.form.confirmPassword,
                    })
                });

                const data = await response.json();

                if (data.error) {
                    this.errors.push(data.error || 'Login failed. Please try again.');
                } else {
                    this.setSetup();
                }

            } catch (error) {
                this.errors.push('An unexpected error occurred. Please try again later.');
                console.error(error);
                this.loading = false;
            }
        },
        clearField(field) {
            let newErrors = [];

            if(field.includes('_')) {
                field = field.replace('_', ' ')
            }
            
            newErrors = this.errors.filter(item => item != `The ${field} is required.`)
            this.errors = newErrors
        },
        goTo(destiny) {
            this.$router.push({name: destiny})
        },
        togglePassword() {
            this.showPassword = !this.showPassword
        },
        toggleConfirmPassword() {
            this.showConfirmPassword = !this.showConfirmPassword
        }
    }
}
</script>